var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgStatistics = function SvgStatistics(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 23,
    height: 13,
    viewBox: "0 0 23 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M22.034 2.016c0 1.078-.938 1.969-2.016 1.969-.188 0-.375 0-.516-.047l-3.563 3.563c.047.141.094.328.094.516 0 1.078-.938 1.969-2.016 1.969s-2.016-.891-2.016-1.969c0-.188.047-.375.094-.516L9.517 4.923a1.683 1.683 0 0 1-.516.094c-.188 0-.375-.047-.516-.094L3.938 9.47c.047.141.094.328.094.516 0 1.078-.938 2.016-2.016 2.016S0 11.064 0 9.986s.938-1.969 2.016-1.969c.188 0 .375 0 .516.047l4.547-4.547c-.047-.141-.047-.328-.047-.516 0-1.078.891-2.016 1.969-2.016s2.016.938 2.016 2.016c0 .188 0 .375-.047.516l2.531 2.531c.141-.047.328-.047.516-.047s.375 0 .516.047l3.563-3.516a1.683 1.683 0 0 1-.094-.516C18.002.938 18.94 0 20.018 0s2.016.938 2.016 2.016Z",
    fill: "currentColor"
  })));
};
export default SvgStatistics;